import { useTranslation } from "react-i18next";
import { formatDateWithRemaining } from "../../../utils/dateFormatter";

export const TenderDeadlineText = ({ date }) => {
  const { t } = useTranslation();
  return formatDateWithRemaining(date, t, { includeRemaining: false });
};
